var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_getPrototype.js
 ** module id = 3034
 ** module chunks = 0
 **/